import { roundMoney } from './currencyFormat';

/**
 * Pricing helpers aligned with AAA Dashboard createFoodOrder:
 * delivery fee from store defaultDeliveryFee; tax on (subtotal − discount + delivery fee) at taxRatePercent.
 * With pricesIncludeTax (Saudi VAT) the tax is already inside the prices: it is shown, not added.
 */

export function formatTaxRateForLabel(rate) {
    const r = Math.min(100, Math.max(0, Number(rate) || 0));
    if (Number.isInteger(r)) return String(r);
    const rounded = Math.round(r * 100) / 100;
    return String(rounded);
}

export function computeDiscountAmountPreview(subtotal, discount) {
    const sub = Number(subtotal) || 0;
    const code = discount?.code;
    if (!discount || code === 'None' || (typeof code === 'string' && !code.trim())) {
        return 0;
    }
    const pct = Number(discount.discountPercentage || 0);
    if (pct > 0) return (sub * pct) / 100;
    const amt = Number(discount.discountAmount || 0);
    if (amt > 0) return amt;
    return 0;
}

export function computeOrderBreakdown({
    subtotal,
    orderType,
    discount,
    defaultDeliveryFee = 0,
    taxRatePercent = 0,
    pricesIncludeTax = false,
    serviceFee = 0,
    tip = 0,
    currency
}) {
    const sub = Number(subtotal) || 0;
    const discountAmount = computeDiscountAmountPreview(sub, discount);
    const netAfterDiscount = Math.max(0, sub - discountAmount);
    const deliveryFee =
        orderType === 'delivery' ? Math.max(0, Number(defaultDeliveryFee) || 0) : 0;
    const taxRate = Math.min(100, Math.max(0, Number(taxRatePercent) || 0));
    const taxableBase = netAfterDiscount + deliveryFee;
    const tax = pricesIncludeTax
        ? roundMoney(taxableBase - taxableBase / (1 + taxRate / 100), currency)
        : roundMoney(taxableBase * (taxRate / 100), currency);
    const taxAdded = pricesIncludeTax ? 0 : tax;
    const sf = Math.max(0, Number(serviceFee) || 0);
    const tp = Math.max(0, Number(tip) || 0);
    const totalAmount = Math.max(0, sub - discountAmount + deliveryFee + sf + taxAdded + tp);

    return {
        subtotal: sub,
        discountAmount,
        netAfterDiscount,
        deliveryFee,
        tax,
        serviceFee: sf,
        tip: tp,
        totalAmount
    };
}
